<template>
  <p-container>
    <p-row>
      <p-col xs12>
        <p-row column dense>
          <h3>
            {{ $t("core.page.verifyUser.page.title") }}
          </h3>
          <p class="caption-1">
            {{ $t("core.page.verifyUser.page.description") }}
          </p>
        </p-row>
      </p-col>
      <p-col xs12>
        <p-form :model="verifyModel" no-summary>
          <p-text-field
            v-model="verifyModel.code"
            :label="$t('core.page.verifyUser.label.verificationCode')"
            @keyup.enter="doVerify()"
          ></p-text-field>
        </p-form>
      </p-col>
      <p-col xs12>
        <p-row>
          <p-button
            :loading="isLoading"
            :disabled="isLoading || !verifyModel.code"
            @click="doVerify()"
          >
            {{ $t("core.page.verifyUser.button.verify") }}
          </p-button>
          <p-button
            tertiary
            link
            :loading="isLoading"
            :disabled="isLoading"
            @click="doResendVerificationCode()"
          >
            {{ $t("core.page.verifyUser.button.resendCode") }}
          </p-button>
        </p-row>
      </p-col>
      <p-col xs12>
        <p-request-alert v-model="requestError"></p-request-alert>
        <p-alert v-model="requestInfo" :dismissable="false" type="info">
          {{ $t('core.page.verifyUser.label.verificationCodeResent') }}
        </p-alert>
      </p-col>
    </p-row>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';
  import VerifyRequestViewModel from '../../../services/v1/viewModel/request/Me/VerifyRequestViewModel';
  import ResendVerificationCodeRequestViewModel from '../../../services/v1/viewModel/request/Me/ResendVerificationCodeRequestViewModel';

  export default Vue.extend({
    auth: true,
    layout: ['layout-exterior', '_exterior'],
    data: () => ({
      isLoading: false,
      requestError: undefined,
      requestInfo: undefined as string | undefined,
      verifyModel: new VerifyRequestViewModel(),
    }),
    methods:
      {
        async doVerify() {
          if (!this.verifyModel.validate()) {
            return;
          }
          this.isLoading = true;
          this.requestError = undefined;
          this.requestInfo = undefined;
          try {
            await this.$service.api.core.me.verify(this.verifyModel);
            await this.$auth.refresh();
            const redirectTarget = this.$config.values['auth-redirects-verify-user-target'];
            if (redirectTarget) {
              Vue.$router.replace({ path: redirectTarget, query: this.$route.query });
            } else {
              Vue.$routerUtils.returnToRedirectOrigin('/');
            }
          } catch (error: any) {
            this.requestError = error;
          }
          this.isLoading = false;
        },
        async doResendVerificationCode() {
          this.isLoading = true;
          this.requestInfo = undefined;
          this.requestError = undefined;
          const email = this.$auth.user?.email;
          try {
            const query = new ResendVerificationCodeRequestViewModel().fromModel({ email: email! });
            await this.$service.api.core.me.resendVerificationCode(query);
            this.requestInfo = this.$t('core.page.verifyUser.label.verificationCodeResent');
          } catch (error: any) {
            this.requestError = error;
          }
          this.isLoading = false;
        },
      },
  });

</script>
